<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">よくある質問</h3>
    </div>
    <div class="page-block__inner">
      <div class="news-detail-area">
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">
              {{ item.title }}
            </p>
          </div>
          <div class="news-detail__body">
            <!-- eslint-disable vue/no-v-html -->
            <p
              class="news-detail__paragraph"
              v-html="item.content">
            </p>
            <!-- eslint-enable vue/no-v-html -->
          </div>
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'faq'}"
            class="c-btn c-btn--back">
            よくある質問トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'FaqDetail',
  components: { HeaderBar },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      item: {},
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get(`/api/client/faqs/${this.id}`)
      this.item = data
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .news-detail__body{
  h1 {
    background-color:#F5C09D;
    padding:5px;
    margin-top:20px;
    font-size:120%;
  }
  img {
    border:1px solid #6D6D6D;
    @media screen and (min-width: 896px){
      max-width:80%;
      margin-top:20px;
      margin-bottom:20px;
      object-fit:scale-down;
    }
    @media screen and (max-width: 895px){
      max-width:80vw;
      margin-top:20px;
      margin-bottom:20px;
      object-fit:scale-down;
    }

  }
}
</style>
